import { ProcessLogViewer } from "../../../../general/src/ProcessLogViewer";
import { Checkbox, DataSource, DateRangeFilter, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPnnLaneBuilderProfile extends Layout {
    checkboxCarrier: Checkbox;
    checkboxCustomer: Checkbox;
    checkboxIncludeInactiveCarriers: Checkbox;
    checkboxIncludeNoDispatchCarrier: Checkbox;
    checkboxIncludeOutOfSvcCarriers: Checkbox;
    checkboxOrderType: Checkbox;
    checkboxRevenueCode: Checkbox;
    checkboxRunFriday: Checkbox;
    checkboxRunMonday: Checkbox;
    checkboxRunSaturday: Checkbox;
    checkboxRunSunday: Checkbox;
    checkboxRunThursday: Checkbox;
    checkboxRunTuesday: Checkbox;
    checkboxRunWednesday: Checkbox;
    checkboxSetPnnActive: Checkbox;
    dateRangeFilter: DateRangeFilter;
    labelOfeverymonth2: Label;
    labelOfeverymonth: Label;
    labelT: Label;
    labelThe: Label;
    layoutProcessLog: ProcessLogViewer;
    panelCheckBoxFilters: Panel;
    panelDaily: Panel;
    panelDayMonth: Panel;
    panelFiltersLeft: Panel;
    panelFiltersRight: Panel;
    panelHeader: Panel;
    panelWeekdayMonth: Panel;
    sourcePnnBuilderProfile: DataSource;
    sourcePnnControl: DataSource;
    switchIsActive: Switch;
    tabFilters: Tab;
    tabHistory: Tab;
    tabLaneCreation: Tab;
    tabReportSettings: Tab;
    tabSchedule: Tab;
    tabsetLaneBuilder: Tabset;
    textboxCarrier: Textbox;
    textboxComment1: Textbox;
    textboxCommentsOption: Textbox;
    textboxContactDetail: Textbox;
    textboxContactOption: Textbox;
    textboxCustomer: Textbox;
    textboxDefaultContact: Textbox;
    textboxDefaultSchedId: Textbox;
    textboxDescr: Textbox;
    textboxEffectiveFrom: Textbox;
    textboxEffectiveTo: Textbox;
    textboxEmailProfileOption: Textbox;
    textboxExcludeEmailDomains: Textbox;
    textboxExistingLanes: Textbox;
    textboxId: Textbox;
    textboxLaneTypeOption: Textbox;
    textboxMinMoves: Textbox;
    textboxMonthDay: Textbox;
    textboxMonthFrequency: Textbox;
    textboxMonthlyDate: Textbox;
    textboxNextGenerateDate: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderType: Textbox;
    textboxOutputType: Textbox;
    textboxRecurringDate: Textbox;
    textboxRevenueCode: Textbox;
    textboxScheduleOption: Textbox;
}
